// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","4348":"taxonomy-edit-tree","4776":"VoltoFormBlockView","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"3724":"b9ae6a1c","4328":"ac119948","4348":"5598ea9f","4776":"ad25ac84","5772":"ac119948"}[chunkId] + ".chunk.css";
};